<script setup lang="ts">
/**
 * UI-kit component
 * Category: 'Kanban components'
 * Name: 'Deadline'
 * FIGMA: 'https://www.figma.com/design/oRsJUOAucnhxx5aeqy4TRO/APP-admin?node-id=14488-40722&t=6CTl5z4NeoYM2d97-4'
 */
import type { KanbanDeadlineProps } from '../types/interfaces'

import { faClock } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import { AppText } from '@shared/ui/typography'
import { IconContainer } from '@shared/ui/other'

import { useKanbanDeadline } from '../composables/use-kanban-deadline.hook'

defineOptions({
  name: 'KanbanDeadline',
})

const props = withDefaults(defineProps<KanbanDeadlineProps>(), {
  expired: false,
  upcoming: false,
})

const {
  refFormattedDate,
} = useKanbanDeadline({ props })
</script>

<template>
  <div :class="['kanban-deadline', { expired, upcoming }]">
    <IconContainer class="kanban-deadline__icon">
      <FontAwesomeIcon :icon="faClock" />
    </IconContainer>
    <AppText
      name="body2"
    >
      {{ refFormattedDate }}
    </AppText>
  </div>
</template>

<style lang="scss" scoped src="../styles/_kanban-deadline.scss" />
